import { useMutation } from '@tanstack/react-query';
import {
  getImpersonateToken,
  GetImpersonateTokenErrorResponse,
  GetImpersonateTokenSuccessResponse,
  GetImpersonateTokenPayload,
} from 'AuthModule/services/impersonateApi';
import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useNotification } from 'hooks/useNotification';
import { extractApiErrorMessage } from 'utils/extractApiErrorMessage';

export const useImpersonateToken = () => {
  const token = useSelector(selectAuthToken);
  const { showError } = useNotification();

  type Variables = {
    payload: GetImpersonateTokenPayload;
    config?: Record<string, any>;
  };

  const mutation = useMutation<
    AxiosResponse<GetImpersonateTokenSuccessResponse>,
    AxiosResponse<GetImpersonateTokenErrorResponse>,
    Variables
  >({
    mutationFn: async ({ payload, config }) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return getImpersonateToken({ params: payload, token, config });
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Getting impersonate token failed! ${extractApiErrorMessage(error)}`);
    },
  });
  return {
    getImpersonateToken: mutation.mutateAsync,
    isGettingImpersonateToken: mutation.isPending,
  };
};
